/* La Florentina forms: character counters (cart gift card, style guide) and the quote form (REQ-QUOTE-1). Deferred, no dependencies. */
(function () {
  'use strict';

  /* Character counter: <textarea data-lf-counter="<id of the output>" maxlength="200"> */
  function updateCounter(field) {
    var output = document.getElementById(field.getAttribute('data-lf-counter'));
    if (output) output.textContent = field.value.length + '/' + field.maxLength;
  }

  document.addEventListener('input', function (event) {
    var field = event.target;
    if (field && field.matches && field.matches('[data-lf-counter]')) updateCounter(field);
  });

  function initCounters() {
    document.querySelectorAll('[data-lf-counter]').forEach(updateCounter);
  }

  /* Quote form */
  var STORAGE_NAME = 'lf-quote-name';
  var STORAGE_VALUES = 'lf-quote-values';

  function safeStorage(action, key, value) {
    try {
      if (action === 'get') return window.sessionStorage.getItem(key);
      if (action === 'set') window.sessionStorage.setItem(key, value);
      if (action === 'remove') window.sessionStorage.removeItem(key);
    } catch (e) {
      return null;
    }
    return null;
  }

  function storageAvailable() {
    try {
      return !!window.sessionStorage;
    } catch (e) {
      return false;
    }
  }

  /* Custom customer event for the Customer Events pixels; the payload stays empty (no personal data) */
  function publish(name) {
    try {
      if (window.Shopify && window.Shopify.analytics && window.Shopify.analytics.publish) window.Shopify.analytics.publish(name, {});
    } catch (e) {
      /* analytics must never break the form */
    }
  }

  function todayISO() {
    var now = new Date();
    var month = ('0' + (now.getMonth() + 1)).slice(-2);
    var day = ('0' + now.getDate()).slice(-2);
    return now.getFullYear() + '-' + month + '-' + day;
  }

  var validators = {
    required: function (field) {
      if (field.type === 'checkbox' || field.type === 'radio') return field.checked;
      return field.value.trim() !== '';
    },
    email: function (field) {
      var value = field.value.trim();
      return value === '' || /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
    },
    tel10: function (field) {
      return /^\d{10}$/.test(field.value.replace(/\s/g, ''));
    },
    'int-min1': function (field) {
      return /^\d+$/.test(field.value.trim()) && parseInt(field.value, 10) >= 1;
    },
    cop: function (field) {
      var digits = field.value.replace(/\D/g, '');
      return digits !== '' && parseInt(digits, 10) > 0;
    },
    'date-future': function (field) {
      return field.value !== '' && field.value >= todayISO();
    },
    consent: function (field) {
      return field.checked;
    }
  };

  var messageKey = { email: 'email', tel10: 'whatsapp', consent: 'consent' };

  function init(root) {
    var form = root.closest('form');
    if (!form || form.dataset.lfReady) return;
    form.dataset.lfReady = 'true';
    form.noValidate = true;

    var submitButton = form.querySelector('[data-lf-quote-submit]');
    var submitting = false;
    var date = form.querySelector('input[type="date"]');
    if (date) date.min = todayISO();

    function message(key) {
      return root.getAttribute('data-msg-' + (messageKey[key] || 'required')) || '';
    }

    function errorFor(field) {
      var id = field.id ? field.id + '-error' : '';
      return id ? document.getElementById(id) : null;
    }

    function setError(field, text) {
      var output = errorFor(field);
      if (text) {
        field.setAttribute('aria-invalid', 'true');
        if (output) {
          output.textContent = text;
          output.hidden = false;
        }
      } else {
        field.removeAttribute('aria-invalid');
        if (output) {
          output.textContent = '';
          output.hidden = true;
        }
      }
    }

    function checkField(field) {
      var tokens = (field.getAttribute('data-lf-validate') || '').split(/\s+/).filter(Boolean);
      for (var i = 0; i < tokens.length; i++) {
        var test = validators[tokens[i]];
        if (test && !test(field)) return message(tokens[i]);
      }
      return '';
    }

    function checkGroup(group) {
      var inputs = group.querySelectorAll('input[type="radio"], input[type="checkbox"]');
      var anyChecked = Array.prototype.some.call(inputs, function (input) {
        return input.checked;
      });
      var output = group.querySelector('.lf-field__error');
      if (output) {
        output.textContent = anyChecked ? '' : message('required');
        output.hidden = anyChecked;
      }
      if (inputs[0]) {
        if (anyChecked) inputs[0].removeAttribute('aria-invalid');
        else inputs[0].setAttribute('aria-invalid', 'true');
      }
      group.dataset.lfInvalid = anyChecked ? '' : 'true';
      return anyChecked ? '' : message('required');
    }

    /* Validates in DOM order, so focus goes to the first invalid element on the page */
    function validateAll() {
      var firstInvalid = null;
      form.querySelectorAll('[data-lf-validate], [data-lf-group="required"]').forEach(function (element) {
        var invalid;
        var target = element;
        if (element.matches('[data-lf-group]')) {
          invalid = checkGroup(element) !== '';
          target = element.querySelector('input');
        } else {
          var text = checkField(element);
          setError(element, text);
          invalid = text !== '';
        }
        if (invalid && !firstInvalid) firstInvalid = target;
      });
      return firstInvalid;
    }

    /* Validate a field when the buyer leaves it, clear its error as soon as it is valid */
    form.addEventListener('focusout', function (event) {
      var field = event.target;
      if (field.matches && field.matches('[data-lf-validate]')) setError(field, checkField(field));
    });
    form.addEventListener('input', function (event) {
      var field = event.target;
      if (field.matches && field.matches('[data-lf-validate][aria-invalid]')) setError(field, checkField(field));
    });

    /* Budget shown as $200.000 */
    var budget = form.querySelector('[data-lf-format="cop"]');
    if (budget) {
      budget.addEventListener('input', function () {
        var digits = budget.value.replace(/\D/g, '');
        budget.value = digits ? '$' + digits.replace(/\B(?=(\d{3})+(?!\d))/g, '.') : '';
      });
    }

    /* Personalization: "Sin personalización" excludes the others; note when under 10 (never blocks) */
    var persGroup = form.querySelector('[data-lf-personalization]');
    var quantity = form.querySelector('#Quote-cantidad');
    var note = form.querySelector('#Quote-personalizacion-note');

    function updateNote() {
      if (!persGroup || !note || !quantity) return;
      var anyPers = persGroup.querySelector('[data-lf-pers]:checked');
      var amount = parseInt(quantity.value, 10);
      note.hidden = !(anyPers && amount >= 1 && amount < 10);
    }

    if (persGroup) {
      persGroup.addEventListener('change', function (event) {
        var changed = event.target;
        if (!changed.matches) return;
        if (changed.matches('[data-lf-pers-none]') && changed.checked) {
          persGroup.querySelectorAll('[data-lf-pers]').forEach(function (box) {
            box.checked = false;
          });
        } else if (changed.matches('[data-lf-pers]') && changed.checked) {
          var none = persGroup.querySelector('[data-lf-pers-none]');
          if (none) none.checked = false;
        }
        updateNote();
        if (persGroup.dataset.lfInvalid) checkGroup(persGroup);
      });
    }
    if (quantity) quantity.addEventListener('input', updateNote);

    form.querySelectorAll('[data-lf-group="required"]').forEach(function (group) {
      group.addEventListener('change', function () {
        if (group.dataset.lfInvalid) checkGroup(group);
      });
    });

    /* Restore what was typed when the server sent the form back with an error */
    if (form.querySelector('[data-lf-quote-error]')) {
      var saved = safeStorage('get', STORAGE_VALUES);
      if (saved) {
        try {
          var values = JSON.parse(saved);
          Object.keys(values).forEach(function (name) {
            var fields = form.querySelectorAll('[name="' + name.replace(/"/g, '\\"') + '"]');
            fields.forEach(function (field) {
              if (field.type === 'checkbox' || field.type === 'radio') {
                field.checked = values[name].indexOf(field.value) !== -1;
              } else if (field.type !== 'hidden') {
                field.value = values[name][0] || '';
              }
            });
          });
        } catch (e) {
          /* ignore a corrupted snapshot */
        }
      }
      updateNote();
    }

    function snapshot() {
      var values = {};
      form.querySelectorAll('input[name], textarea[name], select[name]').forEach(function (field) {
        if (field.type === 'hidden') return;
        if ((field.type === 'checkbox' || field.type === 'radio') && !field.checked) return;
        values[field.name] = values[field.name] || [];
        values[field.name].push(field.value);
      });
      safeStorage('set', STORAGE_VALUES, JSON.stringify(values));
    }

    form.addEventListener('submit', function (event) {
      if (submitting) {
        event.preventDefault();
        return;
      }
      var firstInvalid = validateAll();
      if (firstInvalid) {
        event.preventDefault();
        firstInvalid.focus();
        return;
      }

      /* Shopify chooses the real subject; the requested subject goes first in the body */
      var subject = form.querySelector('[data-lf-subject]');
      var company = form.querySelector('#Quote-empresa');
      if (subject && company && quantity) {
        subject.value = (root.getAttribute('data-subject') || '')
          .replace('__EMPRESA__', function () {
            return company.value.trim();
          })
          .replace('__CANTIDAD__', function () {
            return quantity.value.trim();
          });
      }

      var name = form.querySelector('#Quote-nombre');
      if (name) safeStorage('set', STORAGE_NAME, name.value.trim());
      snapshot();

      submitting = true;
      if (submitButton) {
        submitButton.setAttribute('aria-disabled', 'true');
        submitButton.setAttribute('aria-busy', 'true');
      }
    });

    /* Back navigation restores the page from cache with the form already "submitting" */
    window.addEventListener('pageshow', function (event) {
      if (!event.persisted) return;
      submitting = false;
      if (submitButton) {
        submitButton.removeAttribute('aria-disabled');
        submitButton.removeAttribute('aria-busy');
      }
    });
  }

  function initSuccessAndError() {
    var success = document.querySelector('[data-lf-quote-success]');
    if (success) {
      /* Google Ads "Solicitud de cotización": once per accepted submission. The snapshot exists only
         between submit and this page, so a reload does not publish again. Custom pixel: LF – Google Ads leads. */
      if (safeStorage('get', STORAGE_VALUES) || !storageAvailable()) publish('lf:quote_submitted');
      var slot = success.querySelector('[data-lf-quote-name]');
      var name = safeStorage('get', STORAGE_NAME);
      if (slot && name) slot.textContent = ', ' + name;
      safeStorage('remove', STORAGE_NAME);
      safeStorage('remove', STORAGE_VALUES);
      success.focus({ preventScroll: true });
    }
    var error = document.querySelector('[data-lf-quote-error]');
    if (error) error.focus({ preventScroll: true });
  }

  function start() {
    initCounters();
    document.querySelectorAll('[data-lf-quote]').forEach(init);
    initSuccessAndError();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
